import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { EditorConfig } from '@thehubz/shared/model';
import * as sanitizeHtml from 'sanitize-html';

@Pipe({
  name: 'safePipe',
})
export class SafePipe implements PipeTransform {
  private allowedTags = EditorConfig.allowedTags.concat(['a']);
  private allowedAttributes = Object.assign({}, EditorConfig.allowedAttributes, { a: ['href'] });

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null, type?: 'html' | 'url' | 'string'): SafeHtml | SafeUrl | SafeResourceUrl | null | string {
    if (!value) {
      return value;
    }
    if (type === 'html') {
      return this.sanitizer.bypassSecurityTrustHtml(sanitizeHtml(value, { allowedTags: this.allowedTags, allowedAttributes: this.allowedAttributes }));
    }

    if (type === 'string') {
      return sanitizeHtml(value, { allowedTags: this.allowedTags, allowedAttributes: this.allowedAttributes });
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
